module.exports = "<div class=\"paymentMethods\">\n  <div\n    class=\"paymentMethods-item\"\n    ng-repeat=\"payment in $ctrl.payments track by $index\"\n  >\n    <div>Method : {{payment.method}}</div>\n    <div ng-if=\"payment.method === 'Card'\">\n      Type : {{payment.card.card_subtype}}\n    </div>\n    <div ng-if=\"payment.method === 'Card'\">\n      Pan : {{payment.card.masked_pan}}\n    </div>\n    <md-divider ng-if=\"!$last\"></md-divider>\n  </div>\n\n  <div class=\"no-payments\" ng-if=\"!$ctrl.payments.length\">\n    No Available Payment Methods\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/paymentMethods/paymentMethods.html
// module id = 1021
// module chunks = 0